// services/paymentService.js
import axios from 'axios';
import localRequest from './LocalServer/localRequest';
import logger from './LocalServer/logger';

class PaymentService {
  constructor() {
    this.isProcessing = false;
    this.isvpayWs = null;
    this.isvpayConfig = null;
    this.messageHandlers = new Map();
  }

  // 获取支付方式
  getPaymentMethod() {
    return localStorage.getItem('PAYMENT_METHOD') || 'ORIGINAL';
  }

  // WeVend 直接支付 - 等待最终结果
  async processWeVendPayment(amount, items) {
    try {
      const response = await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/terminal/direct-sale`,
        data: {
          amount: Math.round(amount * 100), // 转换为分
          items: items,
          options: {
            forceDuplicate: false,
            taxAmount: 0,
            merchantFee: 0,
            tipAmount: 0,
          },
        },
        timeout: 120000, // 2分钟超时
      });

      return response.data;
    } catch (error) {
      console.error('WeVend payment failed:', error);
      throw error;
    }
  }

  // 取消 WeVend 支付
  async cancelWeVendPayment() {
    try {
      const response = await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/terminal/cancel`,
        timeout: 10000, // 10秒超时
      });
      return response.data;
    } catch (error) {
      console.error('WeVend cancel failed:', error);
      throw error;
    }
  }

  // 原有支付系统的状态轮询
  async getOriginalPaymentStatus() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_LOCAL_API}/paymentStatus`, {
        headers: {
          'X-CompanyID': 'magex',
          'X-Token': process.env.REACT_APP_X_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Original payment status check failed:', error);
      throw error;
    }
  }

  // 原有支付系统的取消
  async cancelOriginalPayment() {
    try {
      return await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/paymentUpdate`,
        data: {
          status: 'CANCEL',
        },
      });
    } catch (error) {
      console.error('Original payment cancel failed:', error);
      throw error;
    }
  }

  // 设置处理状态
  setProcessing(status) {
    this.isProcessing = status;
  }

  // 获取处理状态
  getProcessingStatus() {
    return this.isProcessing;
  }
}

export default new PaymentService();
